// SteelOps — default fab stages + work centers
//
// These are NOT demo customer/job data. They're the starter taxonomy a brand-
// new shop needs in order for piece marks to have somewhere to route. A real
// shop replaces these via Settings → Configurable Fab Stages (Shop tier).
//
// Per Richard's rule (2026-05-30): no demo SEED_CUSTOMERS / SEED_JOBS /
// SEED_TEAM here. New accounts start empty.

export const DEFAULT_FAB_STAGES = [
  { id: 1, name: 'Detail',       order: 1, color: '#7c3aed' },
  { id: 2, name: 'Material Cut', order: 2, color: '#0891b2' },
  { id: 3, name: 'Fit-Up',       order: 3, color: '#d97706' },
  { id: 4, name: 'Weld',         order: 4, color: '#f97316' },
  { id: 5, name: 'Grind/Clean',  order: 5, color: '#059669' },
  { id: 6, name: 'Paint',        order: 6, color: '#be185d' },
  { id: 7, name: 'Final QC',     order: 7, color: '#dc2626' },
  { id: 8, name: 'Ship',         order: 8, color: '#1e3a5f' },
];

export const DEFAULT_WORK_CENTERS = [
  { id: 1, name: 'Layout & Detail', capacity: 20, color: '#7c3aed' },
  { id: 2, name: 'Fit-Up Bay',      capacity: 15, color: '#0891b2' },
  { id: 3, name: 'Weld Bay 1',      capacity: 12, color: '#d97706' },
  { id: 4, name: 'Weld Bay 2',      capacity: 12, color: '#f97316' },
  { id: 5, name: 'Paint & Finish',  capacity: 18, color: '#059669' },
  { id: 6, name: 'QC / Shipping',   capacity: 25, color: '#1e3a5f' },
];
